import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Switch,
    Tabs,
    Tab,
    Typography,
    Button,
    IconButton,
} from "@mui/material";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CollectionsBookmarkOutlinedIcon from '@mui/icons-material/CollectionsBookmarkOutlined';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import CheckIcon from '@mui/icons-material/Check';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import SearchBar from "../../components/SearchBar";

const Blogs = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");

    // Dummy blog data
    const blogsData = [
        {
            thumbnail: "/static/images/placeholder.png",
            title: "Five Ramadan Gifting Ideas for a Modern Home",
            status: "Published",
            type: "Article",
            reads: "188 reads",
            products: ["Home Decor", "Ramadan"],
            lastUpdated: "Apr 3, 2024",
            isLive: true,
            badges: ["Home Decor", "Ramadan"]
        },
        {
            thumbnail: "/static/images/placeholder.png",
            title: "Understanding CSS Grid",
            status: "Draft",
            type: "Article",
            reads: "45 reads",
            products: ["Web Design"],
            lastUpdated: "Apr 2, 2024",
            isLive: false,
            badges: ["CSS", "Frontend"]
        },
        {
            thumbnail: "/static/images/placeholder.png",
            title: "Introduction to Python for Beginners",
            status: "Published",
            type: "Guide",
            reads: "1.2k reads",
            products: ["Education"],
            lastUpdated: "Mar 28, 2024",
            isLive: true,
            badges: ["Python", "Backend"]
        },
    ];

    // State for toggles per blog
    const [hiddenBlogs, setHiddenBlogs] = useState<number[]>([]);

    const toggleHide = (index: number) => {
        setHiddenBlogs(prev =>
            prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
        );
    };
    return (
        <>
            <div className="main_title">
                <h1>Admin Journals</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Admin Journals
                </p>
            </div>

            <div className="stats_boxes gap_m">
                {/* Featured */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            5
                            <p>Featured <br /> <small style={{ fontSize: '11px', color: '#717171' }}>on Homepage</small></p>
                        </h2>
                        <figure className="warning"> {/* keeping 'warning' or 'blue' based on closest color match, or just use existing classes */}
                            <AutoAwesomeIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="rating_box">
                        <p className="blue" style={{ fontSize: '13px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <span style={{ fontWeight: '700' }}>+3 today</span>
                            {/* <span style={{ fontSize: '11px', color: '#717171' }}>today</span> */}
                        </p>
                    </div>
                </div>

                {/* Curated Products */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            52
                            <p>Curated <br /> <small style={{ fontSize: '11px', color: '#717171' }}>Products</small></p>
                        </h2>
                        <figure className="warning">
                            <CollectionsBookmarkOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="rating_box">
                        <p className="green" style={{ fontSize: '12px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <span style={{ fontWeight: '700' }}>$19.8K</span>
                            <span style={{ fontSize: '11px', color: '#717171' }}>Assisted Sales</span>
                            <CheckIcon sx={{ fontSize: 14 }} />
                        </p>
                    </div>
                </div>

                {/* Flags */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            2
                            <p>Flags <br /> <small style={{ fontSize: '11px', color: '#717171' }}>Posts That need update review</small></p>
                        </h2>
                        <figure className="warning">
                            <FlagOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="rating_box">
                        <p style={{ fontSize: '12px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <span style={{ fontSize: '11px', color: '#717171' }}>Review Queue</span>
                            <KeyboardArrowDownIcon sx={{ fontSize: 16, color: '#f59e0b' }} />
                        </p>
                    </div>
                </div>
            </div>
            <div className="table_flex mt_20">
                <div className="lt">
                    <div className="cards">
                        <div className="table_header">
                            <Box className="left_s">
                                <SearchBar
                                    searchTerm={searchTerm}
                                    setDebouncedSearchTerm={setSearchTerm}
                                    placeholder="Search by blog title or tag..."
                                />
                            </Box>
                            <div className="right_s">
                                <Button
                                    className="btn btn_primary"
                                    onClick={() => navigate("add")}
                                >
                                    Add Blog
                                </Button>
                            </div>
                        </div>

                        <TableContainer className="table_container">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Sr. No.</TableCell>
                                        <TableCell>Thumbnail</TableCell>
                                        <TableCell>Title</TableCell>
                                        <TableCell>Status / Actions</TableCell>
                                        <TableCell>Reads / Listens</TableCell>
                                        <TableCell>Products</TableCell>
                                        <TableCell>Last Updated</TableCell>
                                        <TableCell>Visibility</TableCell>
                                        <TableCell>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {blogsData.map((blog, index) => (
                                        <TableRow key={index} hover style={{ opacity: hiddenBlogs.includes(index) ? 0.6 : 1 }}>
                                            <TableCell>{index + 1}</TableCell>

                                            <TableCell>
                                                <figure style={{ width: '40px', height: '40px', borderRadius: '4px', overflow: 'hidden' }}>
                                                    <img src={blog.thumbnail} alt={blog.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                </figure>
                                            </TableCell>
                                            <TableCell>
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                                    <span style={{ fontWeight: 600, fontSize: '14px', color: '#111827' }}>{blog.title}</span>
                                                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                                        {blog.isLive && (
                                                            <span style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '11px', color: '#d97706', background: '#fffbeb', padding: '2px 6px', borderRadius: '4px' }}>
                                                                <VisibilityOutlinedIcon sx={{ fontSize: 12 }} /> Live
                                                            </span>
                                                        )}
                                                        {blog.badges.map((badge, i) => (
                                                            <span key={i} style={{ fontSize: '11px', color: '#6b7280', background: '#f3f4f6', padding: '2px 6px', borderRadius: '12px', display: 'flex', alignItems: 'center', gap: '2px' }}>
                                                                {badge === 'Ramadan' && <AccessTimeIcon sx={{ fontSize: 10 }} />} {badge}
                                                            </span>
                                                        ))}
                                                    </div>
                                                </div>
                                            </TableCell>

                                            <TableCell>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <span style={{ background: '#fef2f2', color: '#b91c1c', padding: '4px 8px', borderRadius: '12px', fontSize: '12px', fontWeight: 500 }}>
                                                        {blog.status}
                                                    </span>
                                                    <span style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#4b5563', fontSize: '12px' }}>
                                                        <ArticleOutlinedIcon sx={{ fontSize: 14, color: '#059669' }} /> {blog.type}
                                                    </span>
                                                </div>
                                            </TableCell>

                                            <TableCell>
                                                <span style={{ color: '#374151', fontSize: '13px' }}>{blog.reads}</span>
                                            </TableCell>

                                            <TableCell>
                                                <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                                                    {blog.products.map((p, i) => (
                                                        <span key={i} style={{ fontSize: '11px', background: '#f3f4f6', padding: '2px 6px', borderRadius: '4px', color: '#4b5563' }}>
                                                            {p}
                                                        </span>
                                                    ))}
                                                </div>
                                                <small style={{ fontSize: '10px', color: '#9ca3af', display: 'block', marginTop: '4px' }}>Apr 3, 2024</small>
                                            </TableCell>

                                            <TableCell>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <span style={{ color: '#6b7280', fontSize: '13px' }}>{blog.lastUpdated}</span>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <Switch
                                                        size="small"
                                                        checked={!hiddenBlogs.includes(index)}
                                                        onChange={() => toggleHide(index)}
                                                        color="primary"
                                                    />
                                                    <span style={{ fontSize: '12px', color: '#6b7280' }}>
                                                        {hiddenBlogs.includes(index) ? 'Hidden' : 'Visible'}
                                                    </span>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div className="table_actions v2">
                                                    <Box>
                                                        <IconButton onClick={() => navigate("/vendor-blogs/view")}>
                                                            <img src="/static/images/eye_icon.svg" alt="" />
                                                        </IconButton>
                                                        <IconButton onClick={() => navigate("add")}>
                                                            <img src="/static/images/edit2_icon.svg" alt="" />
                                                        </IconButton>
                                                        <IconButton onClick={() => navigate("/vendor-blogs/view")}>
                                                            <img src="/static/images/trash2_icon.svg" alt="" />
                                                        </IconButton>
                                                    </Box>

                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
                <div className="rt">
                    <div className="ai_content_ideas_wrapper">
                        {/* Featured Idea Card */}
                        <div className="content_idea_card">
                            <div className="card_image">
                                <img src="/static/images/placeholder.png" alt="Decor" />
                            </div>
                            <h3>AI Content Ideas</h3>
                            <div className="idea_content">
                                <LightbulbOutlinedIcon className="icon" style={{ fontSize: 16, color: '#d97706' }} />
                                <div className="text">
                                    <h4>5 Ramadan gifting ideas for a modern home</h4>
                                    <p>Highlight our premium home decor pieces that align with Ramadan aesthetic.</p>
                                </div>
                            </div>
                            <button className="generate_btn">
                                <AutoAwesomeIcon style={{ fontSize: 14 }} /> Generate Ideas
                            </button>
                        </div>

                        {/* List Item */}
                        <div className="idea_list_item">
                            <div className="idea_header">
                                <LightbulbOutlinedIcon style={{ fontSize: 16, color: '#d97706' }} />
                                <h3>AI Content Ideas</h3>
                            </div>
                            <div className="idea_content">
                                <h4>5 Ramadan gifting ideas for a modern home</h4>
                                <p>Highlight our premium home decor pieces that align with Ramadan aesthetic.</p>
                            </div>
                        </div>
                    </div>
                    <div className="ai_panel">
                        <h4>AI Insights</h4>

                        <div className="ai_alert warning">
                            <span className="icon">⚠️</span>
                            <p>
                                <b>7 SKUs</b> need immediate attention
                            </p>
                        </div>

                        <div className="ai_alert danger">
                            <span className="icon">⛔</span>
                            <p>
                                <b>3 SKUs</b> have zero sales in 30 days
                            </p>
                        </div>

                        <small className="ai_update">
                            Next updated ETA: <b>May 5, 2024</b>
                        </small>

                        <div className="ai_sku_list">
                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>#PRD_002</h5>
                                    <p>Likely to go out of stock by May</p>
                                </div>
                                <button className="ai_action_btn">Actions ▾</button>
                            </div>

                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>#PRD_010</h5>
                                    <p>Likely to go out of stock by May</p>
                                </div>
                                <button className="ai_action_btn">Actions ▾</button>
                            </div>
                        </div>

                        {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Blogs;
